import { cloneDeep, isEmpty } from 'lodash'
import { POST } from '@/api'

export default {
  namespaced: true,
  state: {
    alertList: {
      empty: [],
      date: [],
    },
    busy: false,
    ended: false,
  },
  mutations: {
    set(state, array) {
      state.alertList = array
    },
    clear(state) {
      state.alertList = { empty: [], date: [] }
      state.ended = false
    },
    busy(state, busy) {
      state.busy = busy
    },
    ended(state, ended) {
      state.ended = ended
    },
  },
  actions: {
    async get(store, limit = 20) {
      const { commit, state } = store
      if (state.busy || state.ended) return

      commit('busy', true)

      const { status, message, data } = await POST('/api/web/alert/list', {
        start: state.alertList.date.length,
        limit,
      })

      if (status !== 200) {
        commit('ended', true)
        commit('app/error', { status, message }, { root: true })
      }

      if (data && !isEmpty(data)) {
        const list = {}

        // emptyがある場合は必ずresponseに含まれる
        const dataList = cloneDeep(data)
        if (dataList.empty) {
          list.empty = dataList.empty
          delete dataList.empty
        }

        // 予約日(index)を追加して配列に再生成
        const alertListDate = Object.keys(dataList).reduce(
          (ary, index) => ary.concat(dataList[index].map(reserve => Object.assign(reserve, { index }))),
          [],
        )
        list.date = store.state.alertList.date.concat(alertListDate)

        commit('set', list)
        commit('ended', isEmpty(dataList))
      } else {
        commit('ended', true)
      }
      commit('busy', false)
    },
    async delete({ commit, state }, data) {
      if (state.busy) return false
      commit('busy', true)

      const { status, message } = await POST('/api/web/alert/delete', data)
      if (status !== 200) commit('app/error', { status, message }, { root: true })

      commit('busy', false)
      return status === 200
    },
  },
}
